import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from '../Generated/ReactUI';

export interface BotImageProps extends React.Props<BotImageControl> {
    bot: Rest.IBot;
    defaultIconUrl: string;
    className?: string;
    transparentBackground?: boolean;
}

export interface BotImageState {
}

export class BotImageControl extends React.Component<BotImageProps, BotImageState> {
    constructor(props : BotImageProps) {
        super(props);
        this.state = {};
    }

    private static hashString(s: string): number {
        if (!s) {
            return 0;
        }
        var hash = 0;
        for (var i = 0; i < s.length; i++) {
            var chr = s.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // ensure hash is integer;
            hash = Math.abs(hash);
        }
        return hash;
    }

    private isDefaultIcon() : boolean {
        const bot = this.props.bot;
        if (!bot || !bot.IconUrl) {
            return true;
        }
        const defaultIconUrl = this.props.defaultIconUrl;
        const prefix = defaultIconUrl.substr(0, defaultIconUrl.lastIndexOf('.'));
        return bot.IconUrl.indexOf(prefix) === 0;
    }

    private mapColorClassName(): string {
        var colorClass = "two-tone-11";
        const bot = this.props.bot;

        if (this.isDefaultIcon()) {
            const paletteIndex = BotImageControl.paletteIndex(bot);
            colorClass = `two-tone-${paletteIndex}`;
        } 
        return colorClass;
    }

    private static skipConflictingColorClasses(classIndex: number): number{  
        if(classIndex === 6 || classIndex === 7 || classIndex === 8){
            return ((classIndex + 3) % 10) + 1;
        }
        return classIndex;  
    }

    private static paletteIndex(bot: Rest.IBot): number {
        const paletteSize = 10;
        const classNum = (BotImageControl.hashString(bot.DefaultIconColorHash || bot.Id) % paletteSize) + 1;
        return BotImageControl.skipConflictingColorClasses(classNum);
    }

    public static hashDefaultIconFileName(bot: Rest.IBot): string {
        return `bot-framework-default-${BotImageControl.paletteIndex(bot)}.png`;
    }

    public render(): JSX.Element {
        var imageClass = `${this.props.className || ''} ${ this.props.transparentBackground ? '' :this.mapColorClassName()}`;

        return (
            <div className={imageClass}>
                <img className="highlight" alt="bot icon" src={this.props.bot.IconUrl}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/BotImageControl.tsx